import {Component} from "@angular/core";
import {FUIAbstractLoader} from "../abstract-loader";

@Component({
    selector: "fui-spinning-loader",
    styleUrls: ["./spinning-loader.component.scss"],
    templateUrl: "./spinning-loader.component.html",
    standalone: false
})
export class FUISpinningLoaderComponent extends FUIAbstractLoader {
}
